// Фильтр каталога продуктов: показывает и прячет карточки, которые сервер
// уже отрисовал, — без запросов и без цепи Blazor.
//
// Разметка (см. Pages/Marketplace/Products.cshtml):
//   [data-catalog]                         корень
//   input[data-catalog-facet="kind"]       чекбокс: platform | locale | released
//   [data-catalog-item]                    карточка с data-platforms, data-locales
//                                          (значения через запятую) и data-released="1|0"
//   [data-catalog-empty]                   блок «ничего не найдено»
//   [data-catalog-reset]                   кнопка сброса
//
// Отмеченные значения складываются по «И»: продукт должен поддерживать все
// выбранные платформы и все выбранные языки.

(function () {
    "use strict";

    const root = document.querySelector<HTMLElement>("[data-catalog]");

    if (!root) {
        return;
    }

    const items = Array.from(root.querySelectorAll<HTMLElement>("[data-catalog-item]"));
    const facets = Array.from(root.querySelectorAll<HTMLInputElement>("input[data-catalog-facet]"));
    const empty = root.querySelector<HTMLElement>("[data-catalog-empty]");

    function split(value: string | undefined): string[] {
        return value ? value.split(",") : [];
    }

    function checked(kind: string): string[] {
        return facets
            .filter((x) => x.checked && x.dataset.catalogFacet === kind)
            .map((x) => x.value);
    }

    function apply(): void {
        const platforms = checked("platform");
        const locales = checked("locale");
        const releasedOnly = checked("released").length > 0;
        let visible = 0;

        items.forEach(function (item) {
            const ownPlatforms = split(item.dataset.platforms);
            const ownLocales = split(item.dataset.locales);

            const show = platforms.every((id) => ownPlatforms.indexOf(id) !== -1)
                && locales.every((id) => ownLocales.indexOf(id) !== -1)
                && (!releasedOnly || item.dataset.released === "1");

            item.classList.toggle("d-none", !show);

            if (show) {
                visible++;
            }
        });

        empty?.classList.toggle("d-none", visible > 0);
    }

    root.addEventListener("change", function (event) {
        if (event.target instanceof HTMLInputElement && event.target.dataset.catalogFacet) {
            apply();
        }
    });

    root.querySelector("[data-catalog-reset]")?.addEventListener("click", function () {
        facets.forEach((x) => { x.checked = false; });
        apply();
    });

    // Браузер может восстановить отметки чекбоксов при возврате на страницу.
    apply();
})();
